import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import telegramAnalytics from "@telegram-apps/analytics";
import store from "./state/store";
import App from "./app";
import { TonConnectUIProvider } from "@tonconnect/ui-react";
import { ta_appname, ta_token, tonMainfestUrl } from "./config";
import "./global.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

if (ta_appname && ta_token) {
  telegramAnalytics.init({
    token: ta_token,
    appName: ta_appname,
  });
}

root.render(
  <React.StrictMode>
    <TonConnectUIProvider manifestUrl={tonMainfestUrl}>
      <Provider store={store}>
        <App />
      </Provider>
    </TonConnectUIProvider>
  </React.StrictMode>
);
